import { AHText } from "arkh";
import React from "react";

const SuggestionItemTitle_ = ({ children }: { children: string | null }) => {
  return (
    <AHText
      type="subtitle"
      spaceTop="xsmall"
      numberOfLines={2}
      style={{ alignContent: "center", textAlign: "center" }}
    >
      {children}
    </AHText>
  );
};
export const SuggestionItemTitle = React.memo(SuggestionItemTitle_);
